/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FeatureCollection } from '../models/feature-collection';
import { getMapFilters } from '../fn/map/get-map-filters';
import { GetMapFilters$Params } from '../fn/map/get-map-filters';
import { getMapStations } from '../fn/map/get-map-stations';
import { GetMapStations$Params } from '../fn/map/get-map-stations';
import { MapFilters } from '../models/map-filters';
import { personalMapStations } from '../fn/personal-space/personal-map-stations';
import { PersonalMapStations$Params } from '../fn/personal-space/personal-map-stations';


/**
 * All about the map features
 */
@Injectable({ providedIn: 'root' })
export class MapService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `personalMapStations()` */
  static readonly PersonalMapStationsPath = '/personalspace/map';

  /**
   * Retrieve personal stations geolocalized on map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalMapStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalMapStations$Response(params: PersonalMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
    return personalMapStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve personal stations geolocalized on map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalMapStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalMapStations(params: PersonalMapStations$Params, context?: HttpContext): Observable<FeatureCollection> {
    return this.personalMapStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureCollection>): FeatureCollection => r.body)
    );
  }

  /** Path part for operation `getMapStations()` */
  static readonly GetMapStationsPath = '/map';

  /**
   * retrieve stations geolocalized on map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMapStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMapStations$Response(params: GetMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
    return getMapStations(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve stations geolocalized on map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMapStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMapStations(params: GetMapStations$Params, context?: HttpContext): Observable<FeatureCollection> {
    return this.getMapStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureCollection>): FeatureCollection => r.body)
    );
  }

  /** Path part for operation `getMapFilters()` */
  static readonly GetMapFiltersPath = '/map/filters/types';

  /**
   * retrieve map filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMapFilters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapFilters$Response(params?: GetMapFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<MapFilters>> {
    return getMapFilters(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve map filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMapFilters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapFilters(params?: GetMapFilters$Params, context?: HttpContext): Observable<MapFilters> {
    return this.getMapFilters$Response(params, context).pipe(
      map((r: StrictHttpResponse<MapFilters>): MapFilters => r.body)
    );
  }

}
